import React from 'react'
import { Route, Routes } from 'react-router-dom'
import UploadPage from './UploadPage'
import LoginPage from './LoginPage'
import Hystory from './PreviousHystory'


function RoutingFile() {
  return (
     <div>
    <Routes>
      <Route exact path="/" element={<LoginPage />} />
      <Route path="/upload" element={<UploadPage />} />
      <Route path="/hystory" element={<Hystory />} />
    </Routes>
  </div>
  )
}

export default RoutingFile
